import { usePaymentDetail } from '@/components/InvoiceReportDetailDrawer/context/PaymentDetailContext';
import { TRANSACTION_MASTER_FIELD_NAMES } from '@/features/transaction_items/constants';
import { Loading } from '@moneyforward/ap-frontend-components';
import { GetInvoiceReportSummaryResponse } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { ApplicationContent } from './ApplicationContent';
import { BasicInfoSection } from './BasicInfoSection';
import { JournalInfo } from './JournalInfo';
import styles from './styles.module.scss';
import { TransactionsDetailSection } from './TransactionsDetail';

const cx = classnames.bind(styles);

type LeftContentProps = {
  data?: GetInvoiceReportSummaryResponse;
  isLoading: boolean;
  reportId: string;
};

const DEFAULT_EXCLUDE_COLUMNS = [TRANSACTION_MASTER_FIELD_NAMES.INVOICE_KIND];

export const LeftContent: FC<LeftContentProps> = memo(
  ({ data, isLoading, reportId }) => {
    const excludeColumns = DEFAULT_EXCLUDE_COLUMNS;
    const { isRightPaneCollapsed } = usePaymentDetail();

    if (isLoading) {
      return (
        <div className={cx('loading-container')}>
          <Loading size='large' color='default' />
        </div>
      );
    }

    if (!data) return null;

    return (
      <div
        className={cx('left-content', { 'full-width': isRightPaneCollapsed })}
      >
        <BasicInfoSection data={data} />
        <ApplicationContent reportId={reportId} />
        <TransactionsDetailSection
          reportId={reportId}
          excludeColumns={excludeColumns}
        />
        <JournalInfo reportId={reportId} />
      </div>
    );
  }
);

LeftContent.displayName = 'LeftContent';
